import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/data/site";
import { openCookiePreferences } from "@/lib/consent";

export const Footer = () => (
  <footer className="text-white mt-20" data-testid="site-footer" style={{ backgroundColor: "#EA155B" }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
      <div className="col-span-2 md:col-span-1">
        <span className="text-2xl font-extrabold" style={{ fontFamily: "Outfit" }}>SENIOR<span style={{ color: "#ffffff" }}>CAR</span><sup className="text-[0.5em] align-super font-bold -ml-0.5">®</sup></span>
        <p className="mt-3 text-white/85 text-sm leading-relaxed">La libertà di continuare a muoversi. Dispositivo medico per la mobilità delle persone con difficoltà motorie.</p>
      </div>
      <div>
        <h4 className="font-bold mb-3 text-white">Prodotto</h4>
        <ul className="space-y-2 text-sm text-white/85">
          <li><Link to="/seniorcar" className="hover:text-white">SENIORCAR</Link></li>
          <li><Link to="/seniorcar/prezzo" className="hover:text-white">Prezzo</Link></li>
          <li><Link to="/seniorcar/scheda-tecnica" className="hover:text-white">Scheda tecnica</Link></li>
          <li><Link to="/mobilita" className="hover:text-white">Mobilità senior</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-bold mb-3 text-white">Approfondisci</h4>
        <ul className="space-y-2 text-sm text-white/85">
          <li><Link to="/dispositivo-medico" className="hover:text-white">Dispositivo medico</Link></li>
          <li><Link to="/guide" className="hover:text-white">Centro Mobilità Senior</Link></li>
          <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          <li><Link to="/assistenza" className="hover:text-white">Assistenza</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-bold mb-3 text-white">Contatti</h4>
        <ul className="space-y-2 text-sm text-white/85">
          <li><a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 hover:text-white"><Phone size={16} /> {PHONE}</a></li>
          <li><a href="mailto:info@seniorcar.it" className="flex items-center gap-2 hover:text-white"><Mail size={16} /> info@seniorcar.it</a></li>
          <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0" /> Via Isaac Newton 9, 20016 Pero (Milano)</li>
          <li><Link to="/offerta" className="hover:text-white font-semibold text-white underline">Prenota Online →</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/70">
        <span data-testid="footer-company">SENIORCAR è un brand di FM FACTORY srl - via Isaac Newton 9 - 20016 Pero Milano - VAT 11919330966</span>
        <span className="flex items-center gap-3 flex-wrap">
          <span>© {new Date().getFullYear()} SENIORCAR. Tutti i diritti riservati.</span>
          <Link to="/privacy" className="hover:text-white underline">Privacy Policy</Link>
          <Link to="/cookie" className="hover:text-white underline">Cookie Policy</Link>
          <button onClick={openCookiePreferences} className="hover:text-white underline" data-testid="footer-cookie-prefs">Preferenze cookie</button>
        </span>
      </div>
    </div>
  </footer>
);
